<template>
  <iframe :src="webUrl+'/admin/platform/service'"></iframe>
</template>

<script>
export default {
  name: "service",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>